import NotificationPanel from "@helsenorge/designsystem-react/components/NotificationPanel";
import { useAppSelector } from "../../store/reducer";
import styles from "../../styles/oppgave-detaljer.module.scss";
import { useGetResources } from "../../hooks/useGetResources";

export const ErrorPanel = (): React.JSX.Element | null => {
  const oppgave = useAppSelector((state) => state.oppgaveDetaljer.oppgave);
  const resources = useGetResources();

  if (oppgave?.OppgaveSvar && oppgave.OppgaveSvar.SendingFeilet) {
    return (
      <NotificationPanel
        className={`${styles.errorpanel} ${styles.detaljer_seksjon}`}
        variant="error"
        label={resources?.error_sendingFeilet_title || ""}
      >
        {resources?.error_sendingFeilet_description || ""}
      </NotificationPanel>
    );
  }
  return null;
};
